export default "__VITE_ASSET__qtLtklXH__"